/*
  Photo gallery. Each photo button opens a dialog showing the larger image,
  with previous and next controls and arrow key support.
*/
if (!customElements.get('photo-gallery')) {
  class PhotoGallery extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      if (!this.dialog || typeof this.dialog.showModal !== 'function') return;

      this.stage = this.querySelector('[data-gallery-stage]');
      this.count = this.querySelector('[data-gallery-count]');
      this.slides = Array.from(this.querySelectorAll('template[data-gallery-slide]'));
      this.buttons = Array.from(this.querySelectorAll('[data-gallery-open]'));
      this.index = 0;

      this.buttons.forEach((button, position) => button.addEventListener('click', () => this.open(position)));
      this.querySelector('[data-gallery-close]').addEventListener('click', () => this.dialog.close());
      this.querySelector('[data-gallery-previous]').addEventListener('click', () => this.show(this.index - 1));
      this.querySelector('[data-gallery-next]').addEventListener('click', () => this.show(this.index + 1));
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.dialog.close();
      });
      this.dialog.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') this.show(this.index - 1);
        if (event.key === 'ArrowRight') this.show(this.index + 1);
      });
      this.dialog.addEventListener('close', () => {
        this.stage.replaceChildren();
        const opener = this.buttons[this.index];
        if (opener) opener.focus();
      });
    }

    open(position) {
      this.show(position);
      this.dialog.showModal();
    }

    show(position) {
      const total = this.slides.length;
      if (!total) return;
      this.index = (position + total) % total;
      this.stage.replaceChildren(this.slides[this.index].content.cloneNode(true));
      this.count.textContent = `${this.index + 1} / ${total}`;
    }
  }

  customElements.define('photo-gallery', PhotoGallery);
}
